import axios from 'axios';
import { createSignedPatchRequest } from 'utils/createSignedRequestsHelpers';

export const patchDeleteFirestopLabel = async (projectId, labelId) => {
  const apiPath = `firestop-documentation/project/${projectId}/firestop-label/${labelId}/delete-firestop-label`;

  const signedRequest = await createSignedPatchRequest({
    apiPath,
    body: {},
  });

  const response = await axios(signedRequest);

  return response.data;
};
